import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import VideoGallery from "../Component/Dynamic/VideoGallery";

function WelcomeScr() {
  const { t, i18n } = useTranslation();

  return (
    <>
      <Container>
        <div>
          <br />
          <img
            src="/imgs/meLabcoat.JPG"
            style={{ width: "70%", borderRadius: "70%" }}
          />
        </div>
        <br />
        {VideoGallery(t("VideoGalleryTitle"))}
        <hr />
      </Container>
    </>
  );
}

export default WelcomeScr;
